import React, { Component } from "react";
import { language } from "settings";
import { DataHandler, ContentHeader, ContactGroup, APIHandler } from "C4";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HashLink as Link } from "react-router-hash-link";

const filter = [
  {
    category: "Travel Trade, North America,  Bahamas Specialist Program",
    link: {
      link: "https://www.bahamas.com/",
      pinterest: "https://pinterest.com/thebahamas/",
      youtube: "https://YouTube.com/user/VisitTheBahamas",
      facebook: "https://www.facebook.com/TravelBahamas",
      instagram: "https://www.instagram.com/VisitTheBahamas/",
      twitter: "https://twitter.com/visitthebahamas",
      linkedin: "http://www.linkedin.com/company/bahamas-ministry-of-tourism/",
    },
  },
  {
    category: "Bahamas Specialist Program & National Trade",
    link: {
      link: "https://www.bahamas.com/",
      pinterest: "https://pinterest.com/thebahamas/",
      youtube: "https://YouTube.com/user/VisitTheBahamas",
      facebook: "https://www.facebook.com/TravelBahamas",
      instagram: "https://www.instagram.com/VisitTheBahamas/",
      twitter: "https://twitter.com/visitthebahamas",
      linkedin: "http://www.linkedin.com/company/bahamas-ministry-of-tourism/",
    },
  },
  {
    category: "Travel Trade, Canada",
    link: {
      facebook: "https://www.facebook.com/BTOToronto/",
      instagram: "https://www.instagram.com/btoCanada/",
      twitter: "https://twitter.com/BTOCANADA1",
    },
  },
  {
    category: "Travel Trade, Florida",
    link: {
      instagram: "https://www.instagram.com/BahamasTouristOffices/",
      twitter: "https://twitter.com/BahamasSales",
    },
  },
  {
    category: "Travel Trade, California / West Coast",
    link: {
      instagram: "https://www.instagram.com/BahamasTouristOffices/",
      twitter: "https://twitter.com/BahamasTourist3",
    },
  },
  {
    category: "Travel Trade, Mid Atlantic / Southeast",
    link: {
      instagram: "https://www.instagram.com/BahamasTouristOffices/",
      twitter: "https://twitter.com/BahamasTourist2",
    },
  },
  {
    category: "Travel Trade, Northeast",
    link: {
      instagram: "https://www.instagram.com/BahamasTouristOffices/",
      twitter: "https://twitter.com/BahamasTourist1",
    },
  },
  {
    category: "Travel Trade, Southwest / Midwest / West Coast",
    link: {
      instagram: "https://www.instagram.com/BahamasTouristOffices/",
      twitter: "https://twitter.com/BahamasTourist3",
    },
  },
  {
    category: "Romance",
  },
  {
    category: "Groups",
  },
  {
    category: "The Carolinas",
  },
  {
    category: "Italy",
  },
  {
    category: "Deutschland",
  },
  {
    category: "France",
  },
];

export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contacts: [],
      categorys: [],
    };
  }

  componentDidMount() {
    this.loadContacts();
  }

  loadContacts() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("mobile")) {
      APIHandler.getContacts(params.get("appId")).then((res) => {
        this.setState({ contacts: res.response });
      });
    } else {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getContacts(appId).then((res) => {
          this.setState({ contacts: res.response });
        });
      });
    }
  }

  render() {
    const { contacts } = this.state;

    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }

    return (
      <div className="contentContainer contact">
        <div className="contacts">
          {filter.map(({ category, link }, i) => (
            <React.Fragment>
              {category && (
                <ContactGroup
                  category={
                    filter[i] !== filter[0]
                      ? category
                      : "REGIONAL MANAGER, SALES & MARKETING"
                  }
                  link={link}
                  contacts={contacts.filter(
                    (contact) =>
                      contact.other_copy.includes(category) ||
                      contact.other_copy === category
                  )}
                />
              )}
            </React.Fragment>
          ))}
        </div>
        {mobile && (
          <style>
            {
              "\
        .cookieConsent { display: none !important; } .header { display: none !important; } .contentContainer { margin-top: 0 !important; }"
            }
          </style>
        )}
      </div>
    );
  }
}
